<template>
  <div class='lt-welcome-page'>
    <header class='lt-welcome-page_content'>
      <h2 class="lt-welcome-title">
        Your Future Income Target
      </h2>
      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
      <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
    </header>

    <div class='lt-fyf-footer'>
      <button
        class="lt-button lt-welcome-page_start-btn"
        @click='startQuiz'
      >
        Start Building Your Future
      </button>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  methods: {
    ...mapMutations([
      'resetScene',
      'goToNextPage',
    ]),
    startQuiz () {
      this.resetScene();
      this.goToNextPage();
    },
  },
};
</script>

<style lang='scss'>

.lt-welcome-page {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 240px;

  @include breakpoint-portrait {
    margin-bottom: 0;
  }
}

.lt-welcome-page_content {
  background: $main-background;
  color: $main-color;
  padding: 1.875rem 2.5rem;
  max-width: 720px;
  box-sizing: border-box;
  margin: 1.25rem auto 0;
  position: relative;
  text-align: center;
  @include breakpoint-portrait {
     padding: 1.875rem 1.25rem 1.25rem 1.25rem;
    @media (max-width: 21.875em) {
      padding: 1.25rem;
    }
  }
  .lt-welcome-title {
  font-size: 3rem;
  @include breakpoint-portrait {
    @media (max-width: 21.875em) {
      font-size: 2rem;
    }
  }

  }
  .lt-welcome-title--large {
    font-size: 4rem;
    @include breakpoint-portrait {
      @media (max-width: 21.875em) {
        font-size: 3rem;
      }
    }
  }
  p {
    margin: 1.25rem 0;
    @include breakpoint-portrait {
      @media (max-width: 21.875em) {
        margin: 0.625rem 0 1.25rem 0;
      }
    }
  }
}
</style>
